import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import { rowGridStyle, tableSectionStyle } from '../FormLines.css';
import { deleteStyle, descriptionStyle, dragHandlerStyle, priceAmountRowStyle, priceAmountStyle, totalStyle } from './LinesHeader.css';

export const LinesHeader = () => {
  const { t } = useTranslation(['lines']);
  const isMobile = useMediaQuery(breakpoints.medium);

  if (isMobile) {
    return null;
  }

  return (
    <thead className={tableSectionStyle}>
      <tr className={rowGridStyle}>
        <th className={dragHandlerStyle} />
        <th className={descriptionStyle}>{t('lines:description.header')}</th>

        <th className={priceAmountStyle}>
          <div className={priceAmountRowStyle}>
            <span>{t('lines:quantity.header')}</span>
            <span>{t('lines:price.header')}</span>
          </div>
        </th>
        <th className={totalStyle}>{t('lines:lineTotal.header')}</th>
        <th className={deleteStyle} />
      </tr>
    </thead>
  );
};
